module.exports = __webpack_public_path__ + "assets/img/32d87c3de675c2d4fbf5697b0990fdbb.png";